export interface Kt {
    id: number;
    value?: any;
}

export interface KtSetting {
    id: number;
    name: string;
    title: string;
    is_show: boolean;
    is_time: boolean;
    drop_down?: string[];
}

export interface TableSetting {
    hash: number;
    is_active: boolean;
}


export interface Settings {
    table: TableSetting;
    columns: KtSetting[];
    control_points_columns: KtSetting[];
}

export interface Record {
    index?: number;
    dist?: string | null;
    selected?: boolean;
    bib: number;
    name: string;
    gun?: string;
    start?: string;
    guntime?: string;
    chiptime?: string;
    result?: string;
    finish?: string;
    last_kt?: Kt;
    kts?: Kt[];
    kts_dict?: { [id: string]: Kt };
    all_kts?: Kt[];

}


export interface SubscribeSettings {
    id: string;
    limit: string;
}

export enum CommandsExternal {
    SUBSCRIBE_ON_UPDATE_DATA = "subscribe_on_update_data",
    GET_SETTINGS = "get_settings",

}

export enum CommandsInner {
    UPDATE_DATA = "update_data",
    UPDATE_SETTINGS = "update_settings",

    SUBSCRIBE_ON_UPDATE_DATA = "subscribe_on_update_data",

    GET_SETTINGS = "get_settings",
    CALLBACK_GET_SETTINGS = "callback_get_settings"

}


export interface Template {
    id: number;
    name: string;
    styles?: { [id: string]: any };
}


//
// let message = {
//     command: "update_table_settings",
//     event: "20190107-omsk",
//     lang: "ru",
// };
//
//
// let columnsSettings = [
//     {field: 0, displayName: "", name: "pid", show: false},
//     {field: 1, displayName: "Номер", name: "bib", show: true},
//     {field: 2, displayName: "Фамилия", name: "last_name", show: true},
//     {field: 3, displayName: "Имя", name: "first_name", show: true},
//     {field: 4, displayName: "Пол", name: "gender", show: true, dropDown: ["Ж", "М"]},
//     {field: 5, displayName: "Категория", name: "cat", show: true, dropDown: ["Ж35+", "М35+"]},
//     {field: 6, displayName: "Дистанция", name: "dist", show: true, dropDown: ["21.1 км", "7 км", "3.5 км"]},
//     {
//         displayName: "Страна",
//         dropDown: ["Россия", "Великобритания", "Австрия", "Германия", "Бельгия", "Казахстан", "Франция", "Испания"],
//         field: 7,
//         name: "country",
//         show: true,
//     },
//     {field: 10, displayName: "Старт", name: "start", show: true},
//     {field: 11, displayName: "Финиш", name: "finish", show: true},
//     {field: 12, displayName: "Личное время", name: "chiptime", show: true},
//     {field: 13, displayName: "1.8 км", name: null, show: true},
//     {field: 14, displayName: "3.5 км", name: null, show: true},
//     {field: 15, displayName: "5.3 км", name: null, show: true},
//     {field: 16, displayName: "7 км", name: null, show: true},
//     {field: 17, displayName: "8.8 км", name: null, show: true},
//     {field: 18, displayName: "10.5 км", name: null, show: true},
//     {field: 19, displayName: "12.3 км", name: null, show: true},
//     {field: 20, displayName: "14 км", name: null, show: true},
//     {field: 21, displayName: "15.8 км", name: null, show: true},
//     {field: 22, displayName: "17.5 км", name: null, show: true},
//     {field: 23, displayName: "19.3 км", name: null, show: true},
// ];
//
// let tableSettings = {
//     count_blocks_tables: 1,
//     order: "desc",
//     rows_count: 1146,
//     sort_by_column: 11,
//     hash: -5397465474180107000,
// };


// command: "subscribe_on_update_data"
// event: "20190107-omsk"
// params: {filters: [], orders: [{type: "desc", column: 11}], rowsCount: 10, page: 1}
// filters: []
// orders: [{type: "desc", column: 11}]
// page: 1
// rowsCount: 10
//
//
// command: "update_data"
// data: {rows: [,…], rowsMax: 1146}
// rows: [,…]
// 0: [2905625, 406, "ГОФМАН", "НИНА", "Ж", "Ж35+", "21.1 км", "Россия", "Омская обл.", "Омск", "00:00:11",…]
// 1: [2905415, 191, "СОЛОМАНИНА", "ПОЛИНА", "Ж", null, "21.1 км", "Россия", "Омская обл.", "Омск",…]
// 2: [2905389, 165, "КУЦЕВОЛ", "ИРИНА", "Ж", "Ж35+", "21.1 км", "Россия", "Омская обл.", "Омский р-н",…]
// 3: [2905714, 540, "РАХАМИНОВА", "ЕЛЕНА", "Ж", "Ж35+", "21.1 км", "Россия", "Омская обл.", "Омск",…]
// 4: [2905299, 68, "BABAK", "NATALIA", "Ж", null, "21.1 км", "Россия", "Омская обл.", "Омск", "00:00:46",…]
// 5: [2905688, 469, "НЕФЕДОВ", "БОРИС", "М", "М35+", "21.1 км", "Россия", "Омская обл.", "Омск", "00:00:20",…]
// 6: [2905504, 282, "СТЕПАНЧИКОВА", "МАРИЯ", "Ж", "Ж35+", "21.1 км", "Россия", "Омская обл.", "Омск",…]
// 7: [2905270, 39, "KASTELIC", "ELISABETH", "Ж", "Ж35+", "21.1 км", "Австрия", null, "Vienna", "00:00:44",…]
// 8: [2905418, 194, "КОЛЯРИ", "ИГОРЬ", "М", "М35+", "21.1 км", "Россия", "Омская обл.",…]
// 9: [2905444, 221, "ВАСИЛЬЕВ", "САМАТ", "М", "М35+", "21.1 км", "Россия", "Респ. Татарстан", "Буинск",…]
// rowsMax: 1146
// meta: {is_active: true}
// is_active: true
// status: "OK"